const PlatformService = {};
export default {
  ...PlatformService,
};
